<section class="stacksBlockContainer" id="block-announcement-bar">
  <div id="settingsTabs" *ngIf="checkSettings()">
    <a (click)="showDataTab()" [ngClass]="checkData() ? 'active' : ''">{{ 'Data' | translate }}</a>
    <a (click)="showStyleTab()" [ngClass]="checkStyle() ? 'active' : ''">{{ 'Style' | translate }}</a>
  </div>

  <!-- Sidebar Icon -->
  <div *ngIf="checkSidebar()" class="blockSidebar" (click)="appendBlock($event)">
    <img src="assets/images/blocks/announcement-bar.svg" alt="Announcement Bar" onerror="this.src='assets/images/blocks/section.png'" />
    <p>{{ 'Announcement Bar' | translate }}</p>
  </div>

  <!-- Preview (mobile + website) -->
  <div class="previewAnnouncementBar previewMobile"
       *ngIf="checkPreview()"
       id="{{ 'blockid' + blockId }}"
       cdkDrag [cdkDragData]="blockId"
       [cdkDragDisabled]="builderType === 'website'">
    <div class="blockControlHandlers" *ngIf="!builderService.globals">
      <div class="editBlock blockActionBtn" (click)="showData(blockId); $event.stopPropagation()">
        <mat-icon>edit</mat-icon>
      </div>
      <div class="blockHandle blockActionBtn" cdkDragHandle>
        <mat-icon>open_with</mat-icon>
      </div>
      <div class="deleteBlock blockActionBtn" (click)="deleteBlock(blockId); $event.stopPropagation()">
        <mat-icon>close</mat-icon>
      </div>
    </div>
    <div class="blockPlaceholder" *cdkDragPlaceholder></div>
    <div class="announcementBarPreview"
      [ngStyle]="{ 'background-color': getBlockFields(blockId)?.style?.bgColor || '#e91e63', color: getBlockFields(blockId)?.style?.textColor || '#ffffff' }">
      <div class="announcementBarTrack" [ngClass]="getBlockFields(blockId)?.data?.variant === 'animated' ? 'animated' : 'static'"
        [style.--announcement-speed.s]="getBlockFields(blockId)?.style?.animationSpeed || 20"
        [innerHTML]="getBlockFields(blockId)?.data?.text | safeHtml">
      </div>
    </div>
  </div>

  <!-- Data Tab -->
  <div class="previewFields" *ngIf="checkData()">
    <div class="sectionSettings">
      <div class="sectionHeader">{{ 'Message' | translate }}</div>
      <editor
        (onSelectionChange)="textChange($event, blockId)"
        apiKey="dh6nv3idqamf38bn1tnknqxd0qn9vz2yli1zjpjehily2stk"
        initialValue="{{ getBlockFields(blockId)?.data?.text || '' }}"
        [init]="{
          base_url: '/tinymce',
          suffix: '.min',
          height: 200,
          menubar: false,
          plugins: ['help'],
          toolbar: 'undo redo | bold italic | help'
        }"
      ></editor>
      <ul>
        <li>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Style' | translate }}</mat-label>
            <mat-select (selectionChange)="queryChange('variant', blockId, $event, 'select')" [(value)]="getBlockFields(blockId).data.variant">
              <mat-option value="static">{{ 'Static' | translate }}</mat-option>
              <mat-option value="animated">{{ 'Animated (Scrolling)' | translate }}</mat-option>
            </mat-select>
          </mat-form-field>
        </li>
        <li>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Position' | translate }}</mat-label>
            <mat-select (selectionChange)="queryChange('position', blockId, $event, 'select')" [value]="getBlockFields(blockId)?.data?.position || 'below-navbar'">
              <mat-option value="below-navbar">{{ 'Below Header' | translate }}</mat-option>
              <mat-option value="above-navbar">{{ 'Above Header' | translate }}</mat-option>
            </mat-select>
          </mat-form-field>
        </li>
        <li>
          <mat-slide-toggle
            (change)="queryChange('dismissible', blockId, $event, 'toggle')"
            [checked]="getBlockFields(blockId).data?.dismissible === true">
            <span>{{ 'Allow visitors to dismiss (close button)' | translate }}</span>
          </mat-slide-toggle>
        </li>
        <li>
          <mat-slide-toggle
            (change)="queryChange('sticky', blockId, $event, 'toggle')"
            [checked]="getBlockFields(blockId).data?.sticky === true">
            <span>{{ 'Stay visible while scrolling (sticky)' | translate }}</span>
          </mat-slide-toggle>
        </li>
      </ul>
    </div>
  </div>

  <!-- Style Tab -->
  <div class="styleFields" *ngIf="checkStyle()">
    <div class="sectionSettings">
      <div class="sectionHeader">{{ 'Colors' | translate }}</div>
      <ul>
        <li class="contentContainerColor">
          <label>{{ 'Background Color' | translate }}</label>
          <mat-form-field>
            <p class="colorPickerValue">{{ getBlockFields(blockId).style?.bgColor || '#e91e63' }}</p>
            <label for="announcementBgColor" class="colorLabel">
              <input type="color" id="announcementBgColor" matInput class="colorPicker" name="announcementBgColor"
                (change)="styleChange('bgColor', blockId, $event, 'text')"
                [value]="getBlockFields(blockId).style?.bgColor || '#e91e63'" />
            </label>
          </mat-form-field>
        </li>
        <li class="contentContainerColor">
          <label>{{ 'Text Color' | translate }}</label>
          <mat-form-field>
            <p class="colorPickerValue">{{ getBlockFields(blockId).style?.textColor || '#ffffff' }}</p>
            <label for="announcementTextColor" class="colorLabel">
              <input type="color" id="announcementTextColor" matInput class="colorPicker" name="announcementTextColor"
                (change)="styleChange('textColor', blockId, $event, 'text')"
                [value]="getBlockFields(blockId).style?.textColor || '#ffffff'" />
            </label>
          </mat-form-field>
        </li>
      </ul>
      <ul *ngIf="getBlockFields(blockId).data?.variant === 'animated'">
        <li>
          <mat-label>{{ 'Scroll Speed (seconds per loop)' | translate }}</mat-label>
          <mat-slider showTickMarks discrete max="60" min="5" step="1" thumbLabel="true">
            <input matSliderThumb ngModel="{{ getBlockFields(blockId).style?.animationSpeed || 20 }}" (change)="animationSpeedChange($event, blockId)" />
          </mat-slider>
        </li>
      </ul>
    </div>
  </div>
</section>
